import { cloneElement } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/ui";
import { PROJECT_STATUS_MAP, CATEGORY_MAP } from "@/features/projects/utils/consts";
import type { BoardProject } from "../../../types/api";

interface Props {
  project: BoardProject;
  onClick: () => void;
}

export default function ProjectOverviewCard({ project, onClick }: Props) {
  const { t } = useTranslation("ProjectsPage");

  const statusInfo = PROJECT_STATUS_MAP[project.status];
  const categoryLabel =
    project.category && CATEGORY_MAP[project.category] ? t(CATEGORY_MAP[project.category].label) : "";

  return (
    <div
      className="relative flex flex-col radius-lg border surface-base-stroke surface-base-fill cursor-pointer hover:shadow-sm overflow-hidden"
      onClick={onClick}>
      <div className="relative w-full h-48">
        {project.project_picture_url ? (
          <img src={project.project_picture_url} alt={project.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-blue-100 to-purple-100" />
        )}
        <div className="absolute top-3 left-3 right-3 flex flex-wrap gap-2">
          <Badge variant="filled" color={statusInfo.color} text={t(statusInfo.label)} dot />
          {categoryLabel && (
            <Badge
              variant="soft"
              color="info"
              text={categoryLabel}
              icon={
                project.category && CATEGORY_MAP[project.category]?.icon
                  ? cloneElement(CATEGORY_MAP[project.category].icon as React.ReactElement<{ size: number }>, {
                      size: 14,
                    })
                  : undefined
              }
            />
          )}
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-heading-md content-base-primary">{project.name}</h3>
      </div>
    </div>
  );
}
